import { render } from "./PatientsChart.vue?vue&type=template&id=ce98ec4c&ts=true"
import script from "./PatientsChart.vue?vue&type=script&lang=ts"
export * from "./PatientsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__